import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { IStudentScore } from "../../../../models/students.model";

interface IProps {
  rawData: IStudentScore[]|undefined;
}

const Participation: FC<IProps> = ({
  rawData,  
}) => {
  const { t } = useTranslation();
  const [tableHeaders, setTableHeaders] = useState<any>([]);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (rawData) {
      const _data: any = _.cloneDeep(rawData);
      const _tableHeaders: any = [];
      _data.forEach((item: any) => {
        item.participationScoreInfo?.forEach((subitem: any) => {
          _tableHeaders.push(subitem);
        });
      });
      setData(_data);
      setTableHeaders(_.uniqBy(_tableHeaders, 'classTimeSeq'));
    }
  }, [rawData]);

  const getScore = (scores: any, classTimeSeq: number) => {
    const score = scores.find((item: any) => item.classTimeSeq === classTimeSeq);
    if (score) {
      return `${score.evaluationInput} (${score.conversionScore})`;
    } else if (score === null) {
      return 'X';
    }

    return 'N/A';
  }

  return tableHeaders.length
    ? (
      <div className='comm-table__area rowType stats mt-0'>
        <table
          style={{ /*maxWidth: `${((tableHeaders?.length || 0) + 1) * 200}px`*/ }}
        >
          <colgroup>
            {[...Array((tableHeaders?.length || 0) + 1)].map((item, index) => (
              <col key={index} width="200px" />
            ))}
          </colgroup>
          <tbody>
            <tr>
              <th />
              {tableHeaders?.map((item: any, index: number) => (
                <th key={index}>{item.classTimeSeq}{t('student.student.column138')}</th>
              ))}
            </tr>
            {data.map((item: any, index: number) => (
              <tr key={index}>
                <td>{moment(item.timetableDate).format('M/D')}</td>
                {tableHeaders?.map((subitem: any, subindex: number) => (
                  <td
                    key={subindex}
                    style={{ backgroundColor: getScore(item.participationScoreInfo, subitem.classTimeSeq) === 'N/A' ? 'gainsboro' : ''}}
                  >
                    {getScore(item.participationScoreInfo, subitem.classTimeSeq) === 'N/A' ? '' : getScore(item.participationScoreInfo, subitem.classTimeSeq)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>        
        </table>
      </div>
      )
    : null;
}

export default Participation;
